 const carousel = () => {
   $('.carousel, .image-gallery--slideshow .image-gallery__images').slick({
    autoplay: true,
    autoplaySpeed: 8000,
    speed: 850,
    dots: true,
    infinite: true,
    centerMode: false,
    prevArrow: '<button class="btn-arrow btn-prev"><span class="sr-only">Previous slide</span><i class="fa-solid fa-chevron-left"></i></button>',
    nextArrow: '<button class="btn-arrow btn-next"><span class="sr-only">Next slide</span><i class="fa-solid fa-chevron-right"></i></button>',
  }).on('beforeChange', function() {
    $('.carousel .slick-track').addClass('animating');
  }).on('afterChange', function() {
    $('.carousel .slick-track').removeClass('animating');
  });

  $('.single-post .entry-content-content .gallery, .page .page-header-small .gallery, .single-job .entry-content-content .gallery, .single-people .sidebar .gallery, .single-project .entry-content-content .gallery, .entry-content .row [class*="col-"] .gallery, .two-column-content .gallery, .tab-pane .gallery').slick({
    autoplay: true,
    autoplaySpeed: 8000,
    speed: 850,
    dots: true,
    infinite: true,
    centerMode: false,
    adaptiveHeight: true,
    prevArrow: '<button class="btn-arrow btn-prev"><span class="sr-only">Previous slide</span><i class="fa-solid fa-chevron-left"></i></button>',
    nextArrow: '<button class="btn-arrow btn-next"><span class="sr-only">Next slide</span><i class="fa-solid fa-chevron-right"></i></button>',
  });
 };

 export default carousel;



// WEBPACK FOOTER //
// ./scripts/carousel.js